import React, { useEffect, useState, useContext } from 'react';
import { Tooltip, Icon } from 'antd';
import { withTranslation } from 'react-i18next';
import { ElementBackgroundPicker } from '../../../artboard/Toolbar/styles';
import ColorPicker from '../../../artboard/ColorPicker';
import { TEXT_BLOCK_TOOLBAR } from '../../../artboard/Toolbar/translationValues';
import { PageElementsContext } from '../../../context/pageElementsContext';
import { CONTEXT_KEYS, useArtboardContext } from '../../../context/complexArtboardContext';

const NAMESPACES = ['TEXT_BLOCK_TOOLBAR'];

const renderColorPicker = (type, { color, setColor, setPicker, styles = {} }) => {
  return (
    <ElementBackgroundPicker style={styles} id={`${type}-picker`}>
      <ColorPicker
        onChange={e => {
          setColor(e.hex);
          setPicker(null);
        }}
        onBlur={() => setPicker(null)}
        color={color || '#000'}
        qlEditor={true}
      />
    </ElementBackgroundPicker>
  );
};

const ElementBackground = ({ t, itemUUID }) => {
  const [picker, setPicker] = useState(null);
  const [color, setColor] = useState(null);
  const { updateComplexElementDetails: updateStoredElementDetails } = useContext(
    PageElementsContext,
  );
  const [{ isCreativeDesign }] = useArtboardContext(
    store => ({
      isCreativeDesign: store[CONTEXT_KEYS.SWITCH_CREATIVE_DESIGN_MENU],
    }),
    'ComplexArtboardSidebar',
  );

  useEffect(() => {
    const selectedToolbar = document.querySelector(`#toolbar-${itemUUID}`);
    if (!selectedToolbar) return;
    if (color) {
      let newStyles = {
        backgroundColor: color,
      };
      updateStoredElementDetails(itemUUID, newStyles, 'style');
    }
  }, [color]);

  return (
    <Tooltip
      placement="top"
      title={t(
        TEXT_BLOCK_TOOLBAR.ELEMENT_BACKGROUND_COLOR_TOOLTIP.key,
        TEXT_BLOCK_TOOLBAR.ELEMENT_BACKGROUND_COLOR_TOOLTIP.value,
      )}
    >
      <Icon
        type="build"
        style={{
          display: isCreativeDesign ? 'flex' : 'none',
          alignItems: 'center',
          justifyContent: 'center',
          width: '30px',
          height: '30px',
          color: 'rgb(255, 255, 255)',
          borderRadius: '10px',
          backgroundColor: 'rgb(177, 39, 44)',
        }}
        onClick={() => setPicker('color')}
      />
      {picker === 'color' &&
        renderColorPicker('color', {
          color,
          setColor,
          setPicker,
        })}
    </Tooltip>
  );
};

export default withTranslation(NAMESPACES)(ElementBackground);
